import axios from 'axios'

const state = {
    list: [],
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
}

const options = {
    headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
    }
};

const actions = {

    getInterventionPlanDetails(context, payload) {
        return axios.get(process.env.VUE_APP_API_BASE_URL+'/intervention_plans/' + payload.planningInterventionId)
            .then((response) => {
                return response
            })
    },

    addInterventionPlan(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL+'/intervention_plans', payload, options)
            .then((response) => {
                return response
            })
    },

    updateStateInterventionPlan(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL+'/intervention_plans/' + payload.planning_intervention_id, payload, options)
            .then((response) => {
                return response
            })
    },

    addInterventionGroup(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL+'/intervention_groups', payload, options)
            .then((response) => {
                return response
            })
    },

    duplicateInterventionGroup(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL+'/intervention_groups/' + payload.interventionGroupId, payload, options)
            .then((response) => {
                return response
            })
    },

    updateInterventionGroup(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL+'/intervention_groups/' + payload.planning_intervention_group_id, payload, options)
            .then((response) => {
                return response
            })
    },

    addInterventionPrevision(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL+'/intervention_previsions', payload, options)
            .then((response) => {
                return response
            })
    },

    deactivateIntervention(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL+'/intervention_previsions/' + payload.interventionPrevisionId, null, options)
            .then((response) => {
                return response
            })
    },

    deleteInterventionGroup(context, payload) {
        return axios.delete(process.env.VUE_APP_API_BASE_URL+'/intervention_groups/' + payload.interventionGroupId)
            .then((response) => {
                return response
            })
    },

}

const getters = {
    list: state => state.list,
};

const interventionPlans = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default interventionPlans;
